import { HEADER_SET_TITLE, HEADER_SET_HEIGHT } from 'store/header/header-actions';
const initialState = {
    data: {
        headerTitle: null,
        height: undefined,
    },
};
export default function headerReducer(state = initialState, { type, payload }) {
    switch (type) {
        case HEADER_SET_TITLE:
            return {
                data: {
                    ...state.data,
                    headerTitle: payload,
                },
            };
        case HEADER_SET_HEIGHT:
            return {
                data: {
                    ...state.data,
                    height: payload,
                },
            };
        default:
            return state;
    }
}
